exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RepeatConsultationDeleteHeader[data-v-5fad9bee]{margin-bottom:20px;color:#251e1c;font-size:18px;text-align:center}.doctorMenu[data-v-5fad9bee]{position:relative;vertical-align:top;width:100%;margin-bottom:10px;padding:20px 25px;background-color:#f9f9f9;border:1px solid #dee2e6;border-radius:6px}@media screen and (max-width:1280px){.doctorMenu[data-v-5fad9bee]{max-width:100%}}", ""]);

// exports
